import { render, staticRenderFns } from "./CompanyChoiceCard.vue?vue&type=template&id=d82251c2&"
import script from "./CompanyChoiceCard.vue?vue&type=script&lang=js&"
export * from "./CompanyChoiceCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChoiceCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports